<script>
  import Navigation from "./Navigation.svelte";
  import { astroData } from "../stores/astroData.js";
  import Details from "./Details.svelte";
  import { pGlyph, sGlyph } from '../stores/glyph.js';
  import { makeReadable, decodeHtml } from '../utils/utils.js';

  $: planeten = $astroData.planets;
  $: huizen = $astroData.houses;

  let pllon = [];
  let midpoints = [];
  // to display in 2 columns we need to split the array in 2 at index 45
  let splitPoint = 45;
  let mPoints1 = [];
  let mPoints2 = [];

  $: if (planeten && huizen) {
    // Initialize pllon and add Ascendant and Midhemel

    pllon = [...planeten];
    pllon.push({ pos: huizen[0].long, naam: "Ascendant" });
    pllon.push({ pos: huizen[9].long, naam: "Midhemel" });

    for (let p1 = 0; p1 <= 11; p1++) {
      for (let p2 = p1 + 1; p2 <= 12; p2++) {
        let graad;
        // check if p1 is a new planet to insert a blank line
        if (p1 > 0 && p2 === p1 + 1) {
          midpoints.push({
            plan1: "",
            plan2: "",
            graad: "",
          });
        }
        if (parseFloat(pllon[p1].pos) > parseFloat(pllon[p2].pos)) {
          graad = parseFloat(pllon[p1].pos) - parseFloat(pllon[p2].pos);
          if (graad > 180) {
            graad = parseFloat(pllon[p2].pos) + 360 - parseFloat(pllon[p1].pos);
            graad = graad / 2 + parseFloat(pllon[p1].pos);
          } else {
            graad = graad / 2 + parseFloat(pllon[p2].pos);
          }
        } else {
          graad = parseFloat(pllon[p2].pos) - parseFloat(pllon[p1].pos);
          if (graad > 180) {
            graad = parseFloat(pllon[p1].pos) + 360 - parseFloat(pllon[p2].pos);
            graad = graad / 2 + parseFloat(pllon[p2].pos);
          } else {
            graad = graad / 2 + parseFloat(pllon[p1].pos);
          }
        }

        midpoints.push({
          plan1: p1,
          plan2: p2,
          graad: graad,
        });
      }
    }
    // midpoints are done. split them in 2 arrays so we can arrange them in two columns
    mPoints1 = midpoints.slice(0, splitPoint);
    mPoints2 = midpoints.slice(splitPoint);
    if (mPoints2.length > 0 && mPoints2[0].plan1 === "" && mPoints2[0].plan2 === "" && mPoints2[0].graad === "") {
    mPoints2.shift();
  }
  }

</script>

<div class="container">
  <Navigation />
  <Details />
  <h3>Midpunten per planeet</h3>
  <div style="display: flex; justify-content: space-between;">
  <table class="alternate">
    {#each mPoints1 as midpoint, i}
      {#if midpoint.plan1 === "" && midpoint.plan2 === "" && midpoint.graad === ""}
        <tr class={i < mPoints1.length - 1 ? "space-after" : ""}>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
        </tr>
      {:else}
        <tr class={i < mPoints1.length - 1 ? "space-after" : ""}>
          <td>
            <span class="planeet astro-font">{@html pGlyph[midpoint.plan1]}</span> /
            <span class="planeet astro-font">{@html pGlyph[midpoint.plan2]}</span>
          </td>
          <td>{@html makeReadable(midpoint.graad, sGlyph)}</td>
        </tr>
      {/if}
    {/each}
  </table>
  <table class="alternate">
    {#each mPoints2 as midpoint, i}  
      {#if midpoint.plan1 === "" && midpoint.plan2 === "" && midpoint.graad === ""}
        <tr class={i < mPoints2.length - 1 ? "space-after" : ""}>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
        </tr>
      {:else}
        <tr class={i < mPoints2.length - 1 ? "space-after" : ""}>
          <td>
            <span class="planeet astro-font">{@html pGlyph[midpoint.plan1]}</span> /
            <span class="planeet astro-font">{@html pGlyph[midpoint.plan2]}</span>
          </td>
          <td>{@html makeReadable(midpoint.graad, sGlyph)}</td>
        </tr>
      {/if}
    {/each}
  </table>
</div>
</div>

<style>
  h3 {
    color: #333;
    font-size: 1.5rem;
    margin-bottom: 15px;
  }

  .alternate {
    border-collapse: collapse;
    width: 100%;
  }

  .alternate td {
    border: 1px solid #ddd;
    padding: 2px;
    text-align: left;
  }

  .alternate tr {
    background-color: #fff;
  }

  .alternate tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  .alternate tr:hover {
    background-color: #ddd;
  }

  .planeet {
    font-weight: bold;
  }
</style>
